import _ from 'underscore'
import TemplateView from '../../TemplateView'
import UserTime from '../../user_time'

export default class VarianceCell extends TemplateView {
    constructor({
        isTimeValue = true
    }) {
        super()

        this.state = {
            value: 0,
        }

        this.params = {
            isTimeValue
        }

        this.placeholder = '--'

        this.onStatePropertyChanged('value', (value) => {
            this.updateValue(value)
        })
    }

    templateHtml() {
        return "<div class='variance'>" +
               "  <div class='value'></div>" +
               "</div>"
    }

    afterRender() {
        this.$value = this.find(".value");
    }

    updateValue(value) {
        if (!_.isNumber(value)) {
            this.$value.removeClass('negative')
            this.$value.text(this.placeholder);
            return
        }

        if (this.params.isTimeValue) {
            this.$value.text(UserTime.formatTimeWithDigitSeparator(value));
        } else {
            this.$value.text((Math.round(value * 100) / 100).toFixed(1) + '%'); }

        this.$value.toggleClass('negative', value < 0)
    }
}



// WEBPACK FOOTER //
// ./web/js/controls/task/VarianceCell.js